import { InfiniteData } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { useDeskId } from '@/hooks/useDeskId';
import { selectUserId } from '@/redux/user/selectors';
import { Conversations } from '@/shared/types/chat';

import { conversationKeys } from './useConversations';
import { useQueryObserver } from './useQueryObserver';
import { NavNotificationKey } from '../models';

const hasUnread = (data: InfiniteData<Conversations>) =>
  !!data?.pages?.[0]?.conversations?.some(({ agent_unread_count }) => agent_unread_count > 0);

const hasAny = (data: InfiniteData<Conversations>) => !!data?.pages?.[0]?.conversations?.length;

// Call from the badge leaf: the RTM fan-out writes to both caches on nearly every event.
export const useNavNotification = (notificationKey: NavNotificationKey): boolean => {
  const deskId = useDeskId();
  const userId = useSelector(selectUserId);
  const isInbox = notificationKey === 'inbox';

  const { data } = useQueryObserver<InfiniteData<Conversations>, boolean>(
    isInbox
      ? conversationKeys.byAgent(deskId, 'open', 'newest', userId)
      : conversationKeys.unassigned(deskId, 'open', 'newest'),
    isInbox ? hasUnread : hasAny
  );

  return !!data;
};
